import React from "react";
import { Route, Routes } from "react-router-dom";

import ROUTES_NAVIGATION from "./routes";
import UserList from "../components/DealerManagement/Admin/UserManagement/UserList";
import AddNewUser from "../components/DealerManagement/Admin/UserManagement/AddUser";
import RoleList from "../components/DealerManagement/Admin/UserManagement/Role/RoleList";
import AddNewRole from "../components/DealerManagement/Admin/UserManagement/Role/AddRole";
import DesignationList from "../components/DealerManagement/Admin/UserManagement/Designation/DesignationList";
import AddNewDesignation from "../components/DealerManagement/Admin/UserManagement/Designation/AddDesignation";
import LanguageList from "../components/DealerManagement/Admin/UserManagement/Languages/LanguageList";
import AddNewLanguage from "../components/DealerManagement/Admin/UserManagement/Languages/AddLanguage";
import PrivilegesComponent from "../components/DealerManagement/Admin/UserManagement/UserPriviledges/PrivilegesComponent";
import EditRole from "../components/DealerManagement/Admin/UserManagement/Role/EditRole";
import EditDesignation from "../components/DealerManagement/Admin/UserManagement/Designation/EditDesignation";
import EditLanguage from "../components/DealerManagement/Admin/UserManagement/Languages/EditLanguage";
import EditUser from "../components/DealerManagement/Admin/UserManagement/EditUser";
import UserPriviledgeComponent from "../components/DealerManagement/Admin/UserManagement/UserList/Priviledges";

const UserRoutes = () => {
  return (
    <>
      {/* <Route path="/cards" element={<ProtectedRoute component={DealerManagement} />} /> */}

      <Route
        path={ROUTES_NAVIGATION.USER_LIST}
        element={<UserList />}
      />
      <Route
        path={ROUTES_NAVIGATION.ADD_USER}
        element={<AddNewUser />}
      />
      <Route
        path={ROUTES_NAVIGATION.EDIT_USER}
        element={<EditUser />}
      />
      <Route
        path={ROUTES_NAVIGATION.ROLELIST}
        element={<RoleList />}
      />
      <Route
        path={ROUTES_NAVIGATION.ADDROLE}
        element={<AddNewRole />}
      />
      <Route
        path={ROUTES_NAVIGATION.EDITROLE}
        element={<EditRole />}
      />
      <Route path={ROUTES_NAVIGATION.DESIGNATIONLIST}
        element={<DesignationList />}
      />
      <Route path={ROUTES_NAVIGATION.ADDDESIGNATION}
        element={<AddNewDesignation />}
      />
      <Route path={ROUTES_NAVIGATION.EDITDESIGNATION}
        element={<EditDesignation />}
      />

      <Route path={ROUTES_NAVIGATION.LANGUAGELIST}
        element={<LanguageList />}
      />
      <Route path={ROUTES_NAVIGATION.ADDLANGUAGE}
        element={<AddNewLanguage />}
      />
      <Route path={ROUTES_NAVIGATION.EDITLANGUAGE}
        element={<EditLanguage />}
      />
      <Route path={ROUTES_NAVIGATION.USERPRIVILEDGES}
        element={<PrivilegesComponent />}
      />
      <Route path={ROUTES_NAVIGATION.USERLISTPRIVILEDGES}
        element={<UserPriviledgeComponent />}
      />


    </>
  );
};

export default UserRoutes;
